export default __webpack_public_path__ + "static/media/red.84ff0362.svg";